import { h } from 'vue';
// import { useRoute } from 'vue-router';
import eventBus from '/@/utils/eventBus';
import { t } from '/@/utils/i18n';
import { useMessage } from './useMessage';
import { LoginRoute } from '/@/router/routes';
import { useUserStore } from '/@/store/modules/user';
import { notifySocket } from '/@/globalNotify/notifySocket';
import { router } from '/@/router';

let modalForToken;
export const useModalForTokenExpired = () => {
  const { createConfirm } = useMessage();
  const userStore = useUserStore();

  // 提示[Vue warn]: inject() can only be used inside setup() or functional components.
  // 由于在setup外面使用导致
  // const route = useRoute();
  const route = router.currentRoute.value;

  return (token = '') => {
    const loginPath = new RegExp(LoginRoute.path);
    // 如果已经在登录页面，则不处理token为''的请求，将弹窗清理
    if (loginPath.test(route?.path) && token === '') {
      // 清理已有的弹窗
      modalForToken?.destroy();
      eventBus.state.tokenChanging = false;
      return;
    }

    if (eventBus.state.tokenChanging) {
      // 已经有弹窗则清理后展示最新的
      modalForToken?.destroy();
    }
    eventBus.state.tokenChanging = true;
    notifySocket.disconnect();
    modalForToken = createConfirm({
      iconType: 'warning',
      title: () => h('span', t('common.warning')),
      content: () => h('span', token ? t('sys.tokenChangeTip') : t('sys.forceLogoutTip')),
      onOk: async () => {
        eventBus.state.tokenChanging = false;
        userStore.setToken(token);
        if (token) {
          // 有token表示切团队
          try {
            await userStore.afterLoginAction(true);
          } finally {
            window.location.reload();
          }
        } else {
          // 强制下线
          userStore.logout(true);
        }
      },
      cancelButtonProps: {
        type: 'default',
        style: { display: 'none' },
      } as any,
      okButtonProps: {
        style: { background: '#f8827b', 'border-radius': '6px', padding: '10px 16px' },
      } as any,
    });
  };
};
